module.exports = __webpack_public_path__ + "img/exit-1.688d88ee.png";